<template>
  <div>
    ข้อมูลโกดัง
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
